import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import CustomHeader from '@/components/common/customHeader.vue';
import { useThemeStore } from '@/stores/theme';
import ErrorNoticeOne from '@/themes/themeOne/Notice/errorNotice.vue';
import ErrorNoticeTwo from '@/themes/themeTwo/Notice/errorNotice.vue';
import ErrorNoticeThree from '@/themes/themeThree/Notice/errorNotice.vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'errorNotice',
  setup(__props) {

const themeStore = useThemeStore()
const router = useRouter()
const goToHome = () => {
    router.push('/home')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createBlock(ErrorNoticeOne, {
          key: 0,
          onGoToHome: goToHome
        }))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createBlock(ErrorNoticeTwo, {
          key: 1,
          onGoToHome: goToHome
        }))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createBlock(ErrorNoticeThree, {
          key: 2,
          onGoToHome: goToHome
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})